define('util/HttpError',[],
function () {
    'use strict';
    /**
     * Create an object that contains error data
     * @param  {Object} error - the error object
     * @return {Object} httpError      [description]
     */
    function HttpError(error) {
        var responseText = error.responseText;
        var contentType = error.getResponseHeader('content-type');
        var retryAfter = error.getResponseHeader('retry-after');

        if(error.statusText === "abort" || error.statusText === "timeout") {
            this.type = error.statusText;
        } else {
            this.type = 'http';
            this.details = {
                status: error.status,
                headers: { retryAfter: retryAfter }
            };

            if (contentType && contentType.indexOf('application/json') === 0 && responseText) {
                this.details.response = JSON.parse(responseText);
            }
        }
    }

    //Enables bluebird targeted catch
    HttpError.prototype = Object.create(Error.prototype);

    return HttpError;
});

